import React from "react";
import { Modal, ModalOverlay, ModalCloseButton, ModalContent } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { updateTypedUserPreference } from "state/userPreference/operations";
import { useUserPreference } from "hooks";

interface OnboardingVideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoURL: string;
}

export const OnboardingVideoModal: React.FC<OnboardingVideoModalProps> = ({ isOpen, onClose, videoURL }) => {
  const dispatch = useDispatch();
  const showOnboardingVideos = useUserPreference("ui_hide_onboarding_videos") as boolean;

  const handleClose = () => {
    onClose();
    !showOnboardingVideos && dispatch(updateTypedUserPreference({ preferenceKey: "ui_onboarding_completed", value: true }));
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered closeOnOverlayClick closeOnEsc>
      <ModalOverlay />
      <ModalContent
        maxWidth={"unset"}
        width={["100vw", "95vw", "95vw"]}
        height={["100vw", "95vh", "95vh"]}
        backgroundColor={"transparent"}
        border="none"
        boxShadow={"none"}>
        <ModalCloseButton backgroundColor={"white"} />
        <iframe
          src={videoURL}
          title="Interacting with Charli"
          style={{
            width: "100%",
            height: "100%",
            colorScheme: "light",
            borderRadius: "0.375rem",
            border: "none",
            display: "block",
          }}
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
          allow="clipboard-write; autoplay"
          allowFullScreen
        />
      </ModalContent>
    </Modal>
  );
};
